import apiClient from '../apiClient';

class LocationService {
  async search(query, options = {}) {
    const normalizedQuery = String(query || '').trim();
    if (normalizedQuery.length < 2) {
      return [];
    }

    const params = new URLSearchParams({
      q: normalizedQuery,
      limit: String(options.limit || 10),
    });

    return apiClient.request(`/job-seeker-profiles/locations/search?${params.toString()}`, {
      method: 'GET',
      signal: options.signal,
    });
  }
}

export default LocationService;
